import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';
import { LoginPage } from "../login/login";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoginServiceProvider } from "../../providers/authservice/loginService";
import { client } from "../../shared/client";
import { user } from "../../shared/user";
import { AuthProvider } from "../../providers/authservice/auth";
import { SignupSuccessPage } from "../signup-success/signup-success";

@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
})
export class SignupPage implements OnInit {

  @ViewChild('signAnimate') sigAnimate;
  signupForm: FormGroup;
  signupOtherForm: FormGroup;
  fullName: AbstractControl;
  restaurantName: AbstractControl;
  restaurantAddress: AbstractControl;
  email: AbstractControl;
  password: AbstractControl;
  ofullName: AbstractControl;
  oemail: AbstractControl;
  opassword: AbstractControl;
  userDetails: user = new user();
  clientDetails: client = new client();
  loading: boolean = true;
  isBusiness: boolean = false;
  isManager: boolean = true;
  isWaiter: boolean = false;
  constructor(

    public navCtrl: NavController,
    public animation: SmartanimationProvider,
    public fb: FormBuilder,
    public loadingCtrl: LoadingController,
    public alrtCtrl: AlertController,
    public loginService: LoginServiceProvider,
    public authService: AuthProvider//,
    //    public iab: InAppBrowser
  ) {
    // constructor function
  }

  changeModel() {
    this.isBusiness = !this.isBusiness;
  }
  changeBusinessType() {
    this.isWaiter = !this.isWaiter;
    this.isManager = this.isBusiness == true && this.isWaiter == false;
  }
  ngOnInit() {

    // form init
    this.signupForm = this.fb.group({
      fname: ['', Validators.compose([Validators.required])],
      resname: ['', Validators.compose([Validators.required])],
      resaddress: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(8)])]
    });
    this.signupOtherForm = this.fb.group({
      fname: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(8)])]
    });

    this.fullName = this.signupForm.controls['fname'];
    this.restaurantName = this.signupForm.controls['resname'];
    this.restaurantAddress = this.signupForm.controls['resaddress'];
    this.email = this.signupForm.controls['email'];
    this.password = this.signupForm.controls['password'];

    this.ofullName = this.signupOtherForm.controls['fname'];
    this.oemail = this.signupOtherForm.controls['email'];
    this.opassword = this.signupOtherForm.controls['password'];
    this.loading = false;
  }

  createAccount(signup_Form: any) {
    if (this.signupForm.valid || this.signupOtherForm.valid) {
      let loading = this.loadingCtrl.create({
        content: 'Please wait creating your account',
        dismissOnPageChange: true
      });
      this.userDetails.IsUser = !this.isBusiness;
      this.clientDetails.Address.res_address = this.isBusiness ? signup_Form.resaddress : '';
      this.clientDetails.Address.res_name = this.isBusiness ? signup_Form.resname : '';
      this.userDetails.email = signup_Form.email;
      this.userDetails.fullname = signup_Form.fname;
      this.isManager = this.isBusiness && !this.isWaiter;
      loading.present();
      this.loginService.userRegistration(signup_Form.email, signup_Form.password)
        .then((response) => {
          const currentUser = this.loginService.getUserId();
          if (this.isManager) {
            this.clientDetails.managerId = response.uid;
            const uid = this.authService.updateResturent(undefined, this.clientDetails);
            this.userDetails.IsUser = false;
            this.userDetails.clientId = uid;
          }
          else if (this.isWaiter) {
            this.userDetails.IsUser = false;
            this.userDetails.clientId = '';
            this.userDetails.desc = ''
            this.userDetails.waiterTo = '-1';
            this.userDetails.resName = signup_Form.resname
            //let serverpath = 'restaurants/-1/servers/'+response.uid+'/isAvailable';
           // this.authService.setWaiterAvailability('restaurants/-1/servers', response.uid, false);
            let serverObj = { userUID: response.uid, fullname: signup_Form.fname ? signup_Form.fname : '', email: signup_Form.email, isAvailable: false, URL: '', desc: '' };
            this.authService.updateWaiterDetails('restaurants/-1/servers', response.uid, serverObj);
            //this.af.object(serverAvilPath).set(item.isAvailable);

            // this.af.list(this.path).push(serverObj).then(res => { console.log(JSON.stringify(res)); });


          }
          this.authService.updateUserDataByUser(response.uid, this.userDetails);

          loading.dismiss().then(() => {
            console.log(currentUser);
            currentUser.sendEmailVerification().then((result) => {
              this.navCtrl.push(SignupSuccessPage, { email: currentUser.email });
            })
          })
        }).catch((error) => {
          loading.dismiss().then(() => {
            this.alertMessage('Registration', error.message);
          })
        })
    }
  };


  // alert Message

  alertMessage(title: string, errorMessage: any) {
    let alrtCtrl = this.alrtCtrl.create({
      title: title,
      subTitle: errorMessage,
      buttons: [{
        text: 'Ok',
        role: 'cancel'
      }]
    });
    alrtCtrl.present();
  }



  // Back to login page
  goToLogin() {
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewWillEnter() {
    this.animation.smartAnimation().setType("fadeIn").show(this.sigAnimate.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts